angular
    .module('tradersyard')
    .directive('promoteForm', [
        '$parse',
        'graph-friend-factory',
        'graph-participant-factory',
        'graph-invite-factory',
        '$flex',
        '$flex.array',
        function ($parse, $friend, $participant, $invite, $flex, $array) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var knowing = ['participant', 'friend', 'all-participant'],
                        tab,
                        initialized = [];

                    $scope.tab = {
                        init: function () {
                            $scope.tab.set(knowing[0]);
                        },
                        is: function (name) {
                            return tab === name;
                        },
                        set: function (name) {
                            tab = name;

                            var init = initialized.indexOf(name) === -1;

                            if (init) initialized.push(name);

                            if ($scope.tab.on.change) $scope.tab.on.change(name, init);
                        },
                        on: {
                            change: undefined,
                        },
                    };

                    var openBtn = angular.element($element[0].querySelector('[promote-open]')),
                        closeBtn = angular.element($element[0].querySelector('[promote-close]')),
                        body = angular.element(document.querySelector('body'));

                    $scope.params = {
                        friend: {
                            page: 0,
                        },
                        participant: {
                            page: 0,
                        },
                        allParticipant: {
                            page: 0,
                            scope: 'around',
                        },
                    };

                    $scope.showModal = false;
                    $scope.role = $attr.promoteRole;
                    $scope.entry = $parse($attr.entry)($scope);

                    $scope.nodes = {
                        friend: [],
                        participant: [],
                        allParticipant: [],
                    };

                    $scope.client = {
                        friend: $friend.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                        participant: $participant.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                        invite: $invite.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                    };

                    $scope.invite = function (node) {
                        $scope.client.invite.create(node.id, { promote: $scope.role }).then(function (response) {
                            if (response.data.state === 0) {
                                node.is_invited = true;
                            }
                        });
                    };

                    $scope.promote = function (node) {
                        $scope.client.participant.update(node.id, { role: $scope.role }).then(function (response) {
                            if (response.data.state === 0) {
                                $array.$splice($parse($attr.pool)($scope)[node.role].data, node, 'id');

                                node.role = response.data.data.role;

                                $parse($attr.pool)($scope)[node.role].data.unshift(angular.copy(node));
                            }
                        });
                    };

                    $scope.delete = function (node) {
                        $scope.client.participant.delete(node.id).then(function (response) {
                            if (response.data.state === 0) {
                                $array.$splice($parse($attr.pool)($scope)[node.role].data, node, 'id');

                                node.role = response.data.data.role;

                                $parse($attr.pool)($scope)[node.role].data.unshift(angular.copy(node));
                            }
                        });
                    };

                    angular.element(document.querySelector('body')).bind('keydown keypress', function (e) {
                        if (e.which === 27) {
                            if ($scope.showModal === true) {
                                closeBtn.triggerHandler('click');

                                e.preventDefault();
                            }
                        }
                    });

                    $scope.tab.on.change = function (name, init) {
                        if (init === true) $scope.load[name]();

                        $flex.$scroll.renew('roles');
                    };

                    var expand = function () {
                        if ($scope.showModal === true) return;

                        $scope.tab.init();

                        body.addClass('no-scroll');
                        $scope.showModal = true;
                    };

                    var hide = function () {
                        body.removeClass('no-scroll');
                        $scope.showModal = false;
                        $flex.$scroll.renew('roles');
                    };

                    openBtn.bind('click', expand);

                    closeBtn.bind('click', hide);
                },
                controller: [
                    '$scope',
                    function ($scope) {
                        $scope.load = {
                            friend: function (next) {
                                ++$scope.params.friend.page;
                                $scope.client.friend.query({ params: $scope.params.friend }).then(function (response) {
                                    if (response.data.state === 0 && response.data.data.length > 0) {
                                        $scope.nodes.friend = $scope.nodes.friend.concat(response.data.data);

                                        if (next) next();
                                    }
                                });
                            },
                            participant: function (next) {
                                ++$scope.params.participant.page;
                                $scope.client.participant
                                    .query({ params: $scope.params.participant })
                                    .then(function (response) {
                                        if (response.data.state === 0 && response.data.data.length > 0) {
                                            $scope.nodes.participant = $scope.nodes.participant.concat(
                                                response.data.data
                                            );

                                            if (next) next();
                                        }
                                    });
                            },
                            allParticipant: function (next) {
                                ++$scope.params.allParticipant.page;
                                $scope.client.participant
                                    .query({ params: $scope.params.allParticipant })
                                    .then(function (response) {
                                        if (response.data.state === 0 && response.data.data.length > 0) {
                                            $scope.nodes.allParticipant = $scope.nodes.allParticipant.concat(
                                                response.data.data
                                            );

                                            if (next) next();
                                        }
                                    });
                            },
                        };
                    },
                ],
            };
        },
    ])
    .directive('promoteNode', [
        '$parse',
        'graph-friend-factory',
        'graph-participant-factory',
        'graph-invite-factory',
        '$flex',
        '$flex.array',
        '$timeout',
        function ($parse, $friend, $participant, $invite, $flex, $array, $timeout) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    $scope.mode = 'read';

                    $scope.roles = [];
                    $scope.role = '';

                    var entry,
                        entryId,
                        client = {
                            participant: undefined,
                            invite: undefined,
                        },
                        type = 'participant';

                    $timeout(function () {
                        entry = $parse($attr.entry)($scope);

                        entryId = $parse($attr.entryId)($scope);

                        $scope.role = $parse($attr.nodeRole)($scope);

                        var promoteType = $parse($attr.promoteType)($scope);

                        if (['participant', 'invite'].indexOf(promoteType) !== -1) type = promoteType;

                        if (entry === 'group') {
                            $scope.roles = ['owner', 'executive', 'presenter', 'trader', 'pretrader', 'listener'];
                        } else {
                            $scope.roles = ['owner', 'presenter', 'listener'];
                        }

                        client.participant = $participant.entry(entry, entryId);
                        client.invite = $invite.entry(entry, entryId);
                    });

                    $scope.cancel = function (node) {
                        $scope.mode = 'read';
                    };

                    $scope.edit = function (node) {
                        $scope.mode = 'edit';
                    };

                    function webinarPresenterResolver(participant, presenters, listeners) {
                        var participantInPresenters = false;

                        listeners.data.forEach(function (listener, index) {
                            if (listener.id === participant.id) {
                                participantInPresenters = true;
                                listener.role = 'presenter';
                                presenters.data.unshift(listener);
                                listeners.data.splice(index, 1);
                            }
                        });

                        presenters.data.forEach(function (presenter, index) {
                            if (presenter.id !== participant.id) {
                                presenter.role = 'listener';
                                listeners.data.unshift(presenter);
                                presenters.data.splice(index, 1);
                            } else {
                                participantInPresenters = true;
                            }
                        });

                        return participantInPresenters;
                    }

                    $scope.save = function (node) {
                        $scope.mode = 'edit';
                        if (type === 'participant') {
                            client.participant.update(node.id, { role: $scope.role }).then(function (response) {
                                if (response.data.state === 0) {
                                    var participantInPresenters = false;

                                    if (entry === 'webinar' && response.data.data.role === 'presenter') {
                                        participantInPresenters = webinarPresenterResolver(
                                            response.data.data,
                                            $parse($attr.pool)($scope).presenter,
                                            $parse($attr.pool)($scope).listener
                                        );

                                        if (node.role === 'owner') {
                                            $array.$splice($parse($attr.pool)($scope)[node.role].data, node, 'id');
                                        }
                                    } else {
                                        if ($attr.pool) {
                                            $array.$splice($parse($attr.pool)($scope)[node.role].data, node, 'id');
                                        }
                                    }

                                    node.role = response.data.data.role;

                                    if ($attr.pool && !participantInPresenters) {
                                        $parse($attr.pool)($scope)[node.role].data.unshift(angular.copy(node));
                                    }

                                    $scope.mode = 'read';
                                }
                            });
                        } else if (type === 'invite') {
                            client.invite.create(node.id, { promote: $scope.role }).then(function (response) {
                                if (response.data.state === 0) {
                                    if ($attr.pool) {
                                        $array.$splice($parse($attr.pool)($scope)[node.promote].data, node, 'id');
                                    }

                                    node.promote = $scope.role;

                                    if ($attr.pool) {
                                        $parse($attr.pool)($scope)[node.promote].data.unshift(angular.copy(node));
                                    }

                                    $scope.mode = 'read';
                                }
                            });
                        }
                    };

                    $scope.delete = function (node) {
                        if (type !== 'participant') return;

                        client.participant.delete(node.id).then(function (response) {
                            if (response.data.state === 0) {
                                if ($attr.pool) {
                                    $array.$splice($parse($attr.pool)($scope)[node.role].data, node, 'id');
                                }

                                node.role = response.data.data.role;

                                if ($attr.pool) {
                                    $parse($attr.pool)($scope)[node.role].data.unshift(angular.copy(node));
                                }
                            }
                        });
                    };
                },
            };
        },
    ])
    .directive('migrateForm', [
        '$parse',
        'graph-participant-factory',
        'graph-invite-factory',
        '$flex',
        '$flex.array',
        function ($parse, $participant, $invite, $flex, $array) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var openBtn = angular.element($element[0].querySelector('[migrate-open]')),
                        closeBtn = angular.element($element[0].querySelector('[migrate-close]')),
                        body = angular.element(document.querySelector('body')),
                        status = false;

                    $scope.entry = $parse($attr.entry)($scope);
                    $scope.entryId = $parse($attr.entryId)($scope);

                    $scope.roles = ['owner', 'executive', 'presenter', 'trader', 'pretrader', 'listener'];

                    $scope.params = {
                        page: 0,
                    };

                    $scope.showModal = false;

                    $scope.nodes = [];

                    $scope.client = {
                        invite: $invite.entry($scope.entry, $scope.entryId),
                        participant: $participant.entry($scope.entry, $scope.entryId),
                    };

                    $scope.invite = function (node) {
                        var options = {
                            override: node.override,
                        };

                        if (node.sync) {
                            options.sync = node.sync;
                            options.role = node.role;
                        }

                        $scope.client.invite
                            .massInvite(node.location.name, node.location.id, options)
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    for (var i = 0; i < $scope.nodes.length; ++i) {
                                        if (
                                            $scope.nodes[i].place.id === node.place.id &&
                                            $scope.nodes[i].place.name === node.place.name
                                        ) {
                                            $scope.nodes.splice(i, 1);
                                        }
                                    }
                                }
                            });
                    };

                    var expand = function () {
                        if ($scope.showModal === true) return;

                        if (!status) {
                            status = true;
                            $scope.load.ownership();
                        }

                        body.addClass('no-scroll');
                        $scope.showModal = true;
                    };

                    var hide = function () {
                        body.removeClass('no-scroll');
                        $scope.showModal = false;
                        $flex.$scroll.renew('roles');
                    };

                    openBtn.bind('click', expand);

                    closeBtn.bind('click', hide);
                },
                controller: [
                    '$scope',
                    function ($scope) {
                        $scope.load = {
                            ownership: function (next) {
                                ++$scope.params.page;
                                $scope.client.participant
                                    .ownership({ params: $scope.params })
                                    .then(function (response) {
                                        if (response.data.state === 0 && response.data.data.length > 0) {
                                            angular.forEach(response.data.data, function (entry) {
                                                entry.override = true;
                                                entry.dropdown = false;
                                                entry.sync = false;
                                                entry.role = 'owner';
                                            });

                                            $scope.nodes = $scope.nodes.concat(response.data.data);

                                            if (next) next();
                                        }
                                    });
                            },
                        };
                    },
                ],
            };
        },
    ]);
